import ZoneTableComponent from './ZoneTableComponent/ZoneTableComponent.vue'
import POITableComponent from './POITableComponent/POITableComponent.vue'
import i18n from '@/i18n'
import { zoneService } from '@/services/zone.service'
import { driveUnitService } from '@/services/driveUnit.service'
import { thingService } from '@/services/thing.service'
import { poiService } from '@/services/poi.service'
import { mapService } from '@/services/map.service'
import { enterpriseService } from '@/services/enterprise.service'
import { mapActions, mapGetters } from 'vuex'
import { SnackbarStyle } from '@/constants/constants'
import service from '@/middleware'
import { dialogTypes } from '@/constants/dialogTypes'
import DriveUnitDialogComponent from "@/components/drive-unit/dialog/DriveUnitDialogComponent.vue"
import { DialogDriveUnit, dialogUtil } from '@/tools/dialog'
import EcologicalUnitDialogComponent from "@/components/ecological-unit/dialog/EcologicalUnitDialogComponent.vue";
import FarmDialogComponent from "@/components/farm/dialog/FarmDialogComponent.vue";
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";
import ZoneColorDialogComponent from "@/components/zone/dialog/ZoneColorDialogComponent.vue";
import { configurationService } from "@/services/configuration.service";
import { categoryService } from '../../services/category.service'

export default {
  name: 'ZoneABMComponent',
  components: {
    POITableComponent,
    ZoneTableComponent,
    DriveUnitDialogComponent,
    EcologicalUnitDialogComponent,
    FarmDialogComponent,
    AutocompleteComponent,
    ZoneColorDialogComponent
  },
  props: {
  },
  data: () => ({
    mapConfiguration: [],
    selectedTab: 'tab-map',
    tabs: [
      {
        id: 'tab-map',
        name: i18n.t('zone.map')
      },
      {
        id: 'tab-table',
        name: i18n.t('zone.zones')
      },
      {
        id: 'tab-table-poi',
        name: i18n.t('zone.pois')
      }
    ],
    update: false,
    zone: null,
    zoneToEdit: null,
    poi: null,
    poiToEdit: null,
    zonesAndPOIs: [],
    enterpriseCategories: [],
    middleware: service.http,
    selectedCategoryFilter: null,
    enterpriseSelected: null,
    enterprises: [],
    // Opción 'TODOS' para el selector de empresa
    all: {
      _id: 'ALL',
      name: i18n.t('all')
    },
    enterpriseSelectedArray: [],
    zoneSelectors: {
      categories: [],
      enterprises: []
    },
    poiSelectors: {
      categories: [],
      enterprises: [],
      vehicles: [],
      activities: []
    },
    showMenu: false,
    dialog: {
      ...dialogTypes.DRIVE_UNIT,
    },
    // model del dialog
    showDriveUnitDialog: false,
    // título del dialog
    driveUnitDialogTitle: i18n.t('driveUnit.dialog.titleNew'),
    // diálogo de cambio de color
    showColorDialog: false,
    selectedZonesForColor: [],
    showThings: false,
    showClustersValue: true,
    customButtonsMap: [
    ],
    showZones: false,
    showPoi: false,
    loadingMap: true,
    zoneNames: [],
  }),
  computed: {
    /**
     * getters del breadcrumb para el dialog
     */
    ...mapGetters('breadcrumbs', [
      'getBread'
    ])
  },
  created() {
    this.customButtonsMap.push(
      { icon: "fa-map-signs", function: this.showHideZones.bind(this), tooltip: i18n.t('zone.showZones') },
      { icon: "mdi-pin", function: this.showHidePoi.bind(this), tooltip: i18n.t('zone.showPois') }
    )
    this.unwatch = this.$store.watch(
      (state, getters) => getters['breadcrumbs/getBread'],
      async (newBreads) => {
        const lastElemet = newBreads[newBreads.length - 1]
        if (!lastElemet) {
          this.cancel()
          this.$refs.zoneTable && this.$refs.zoneTable.refreshTable && this.$refs.zoneTable.refreshTable()
          this.$refs.zoneMap && this.$refs.zoneMap.refreshTable && this.$refs.zoneMap.refreshTable()

          return
        }
        this.dialog = dialogUtil.getDialog(lastElemet.key, DialogDriveUnit)
      },
      { deep: true })
  },
  async mounted() {
    await this.initEnterpriseSelector()
    await this.getZonesAndPOIS()
    await this.initEnterpriseCategoriesSelector()
  },
  beforeMount() {
    this.showClustersValue = configurationService.getShowCluster('ZoneABM')
  },
  beforeDestroy() {
    this.unwatch()
    this.cleanBread()
  },
  methods: {
    /**
     * actions del snackbar
     */
    ...mapActions('snackbar', [
      'showSnackbar',
      'closeSnackbar'
    ]),
    /**
     * actions del breadcrumbs
     */
    ...mapActions('breadcrumbs', [
      'pushBread',
      'pullBread',
      'cleanBread'
    ]),

    async showHideZones() {
      this.showZones = !this.showZones;
      if (!this.showZones) {
        const groups = this.mapConfiguration[0].groups.filter(group => !group.id || (group.id !== 'zones'))
        this.mapConfiguration[0].groups = groups ? groups : []
      } else {
        await this.getZonesAndPOIS();
      }
    },

    async showHidePoi() {
      this.showPoi = !this.showPoi;
      if (!this.showPoi) {
        const groups = this.mapConfiguration[0].groups.filter(group => !group.id || (group.id !== 'poi'))
        this.mapConfiguration[0].groups = groups ? groups : []
      } else {
        await this.getZonesAndPOIS();
      }
    },
    /**
     * Inicializa el selector de empresas
     */
    async initEnterpriseSelector() {
      this.enterprises = await enterpriseService.getAllForSelector()
      if (this.enterprises.length > 0) {
        // this.enterprises = ([this.all]).concat(this.enterprises)
        // this.enterpriseSelected = this.all._id
        this.enterpriseSelected = this.enterprises[0]._id
      }
      this.updateSelectors()
    },
    /**
     * Inicializa el selector de categorias de la empresa
     */
    async initEnterpriseCategoriesSelector() {
      this.enterpriseCategories = await categoryService.getCategoriesByEnterpriseId(this.enterpriseSelected)
    },
    /**
     * Inicializar las zonas en el mapa
     */
    async getZonesAndPOIS() {
      this.loadingMap = true;
      try {
        const [zoneResponse, poiResponse, zoneCategories, poiCategories] = await Promise.all([
          zoneService.findAll([this.enterpriseSelected], true, this.selectedCategoryFilter ? this.selectedCategoryFilter : ''),
          poiService.findAll([this.enterpriseSelected]),
          zoneService.getCategories(this.enterpriseSelected),
          poiService.getCategories(this.enterpriseSelected)
        ])
        if (this.zone) {
          zoneResponse.data = zoneResponse.data.filter((m) => {
            return m._id !== this.zone._id;
          })
        }
        this.zoneNames = zoneResponse?.data?.map(m => m.name);
        if (this.poi) {
          poiResponse.data = poiResponse.data.filter((m) => {
            return m._id !== this.poi._id;
          })
        }
        const mapFinal = this.getMap(zoneResponse.data, poiResponse.data, poiCategories)
        const currentStateMap = await mapService.getCurrentState(this.enterpriseSelected)
        if (this.showThings && currentStateMap && currentStateMap.map && currentStateMap.map.groups && currentStateMap.map.groups[0]) {
          mapFinal.groups.push(currentStateMap.map.groups[0])
        }
        this.mapConfiguration = [mapFinal]
        let poiResult = zoneResponse.data.map(d => ({
          _id: d._id,
          name: d.name,
          position: [d.geometry.coordinates[0][0][1], d.geometry.coordinates[0][0][0]],
          category: d.category
        })).concat(
          poiResponse.data.map(d => ({
            _id: d._id,
            name: d.name,
            position: d.center,
            category: d.category
          }))
        )
        if (this.selectedCategoryFilter && this.selectedCategoryFilter !== '') {
          poiResult = poiResult.filter(p => p.category === this.selectedCategoryFilter);
        }
        this.zonesAndPOIs = poiResult;
        this.zoneSelectors.categories = zoneCategories
        this.poiSelectors.categories = poiCategories
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingMap = false;
      }
    },
    async updateSelectors() {
      this.enterpriseSelectedArray.cleanAndUpdate(this.getEnterpriseSelectedArray());
      this.zoneSelectors.enterprises.cleanAndUpdate(this.getZoneEnterprises());
      const enterpriseIds = this.getZoneEnterprises().map(e => e._id);
      const [enterpriseSelector, vehicleSelector, activitySelector] = await Promise.all([
        thingService.getAllNestedByEnterprise(enterpriseIds),
        thingService.getAllNested(enterpriseIds),
        thingService.getAllNestedByActivity(enterpriseIds),
      ])
      this.poiSelectors.enterprises.cleanAndUpdate(enterpriseSelector);
      this.poiSelectors.vehicles.cleanAndUpdate(vehicleSelector);
      this.poiSelectors.activities.cleanAndUpdate(activitySelector);
    },
    getEnterpriseSelectedArray() {
      if (this.enterpriseSelected) {
        if (this.enterpriseSelected === this.all._id) {
          return this.enterprises.filter(enterprise => enterprise._id !== this.all._id)
            .map(enterprise => enterprise._id)
        } else {
          return [this.enterpriseSelected]
        }
      } else {
        return []
      }
    },
    getZoneEnterprises() {
      if (this.enterpriseSelected) {
        if (this.enterpriseSelected === this.all._id) {
          return this.enterprises.filter(enterprise => enterprise._id !== this.all._id)
        } else {
          return this.enterprises.filter(enterprise => enterprise._id === this.enterpriseSelected)
        }
      } else {
        return []
      }
    },
    createZone(zone) {
      zoneService.create(zone).then(async () => {
        this.showSnackbar({
          visible: true,
          text: this.$t('zone.successCreateMessage'),
          timeout: 6000,
          style: SnackbarStyle.SUCCESS
        })
        await this.getZonesAndPOIS()
        if (this.$refs.zoneTable) this.$refs.zoneTable.getData(true)
      })
    },
    updateZone(zone) {
      this.update = false
      zone._id = this.zone._id
      zoneService.update(zone).then(async () => {
        this.zone = null
        this.zoneToEdit = null
        this.showSnackbar({
          visible: true,
          text: this.$t('zone.successUpdateMessage'),
          timeout: 6000,
          style: SnackbarStyle.SUCCESS
        })
        await this.getZonesAndPOIS()
        if (this.$refs.zoneTable) this.$refs.zoneTable.getData(true)
      })
    },
    createPoi(poi) {
      // agrego empresa al poi
      poi.enterpriseIds = [this.enterpriseSelected]
      poiService.create(poi).then(async () => {
        this.showSnackbar({
          visible: true,
          text: this.$t('poi.successCreateMessage'),
          timeout: 6000,
          style: SnackbarStyle.SUCCESS
        })
        await this.getZonesAndPOIS()
        if (this.$refs.poiTable) this.$refs.poiTable.getData(true)
      })
    },
    updatePoi(poi) {
      this.update = false
      poi._id = this.poi._id
      poiService.update(poi).then(async () => {
        this.poi = null
        this.poiToEdit = null
        this.showSnackbar({
          visible: true,
          text: this.$t('poi.successUpdateMessage'),
          timeout: 6000,
          style: SnackbarStyle.SUCCESS
        })
        await this.getZonesAndPOIS()
        if (this.$refs.poiTable) this.$refs.poiTable.getData(true)
      })
    },
    async drawingSaved({ drawingType, drawing }) {
      if (drawingType === 'ZONE') {
        if (this.update) {
          await this.updateZone(drawing)
        } else {
          await this.createZone(drawing)
        }
      } else if (drawingType === 'POI') {
        if (this.update) {
          this.updatePoi(drawing)
        } else {
          this.createPoi(drawing)
        }
      }
    },
    async startEditingZone(data) {
      this.update = true
      zoneService.getZone(data._id).then(res => {
        this.zone = res
        this.selectedTab = 'tab-map'
      })
    },
    startEditingPoi(data) {
      this.update = true
      poiService.getPoi(data._id).then(res => {
        this.poi = res
        this.selectedTab = 'tab-map'
      })
    },
    async finishDrawing() {
      this.update = false
      this.zone = null
      this.zoneToEdit = null
      this.poi = null
      this.poiToEdit = null
      await this.getZonesAndPOIS();
    },
    async showVehicles() {
      if (this.showThings) {
        const groups = this.mapConfiguration[0].groups.filter(m => !m.id || (m.id.toString() !== 'things'))
        this.mapConfiguration[0].groups = groups ? groups : []
      } else {
        await this.getZonesAndPOIS();
      }
      this.showThings = !this.showThings
    },

    getZoneGroupMap(zones) {
      const series = [];
      const references = [];
      zones.forEach(d => {
        const serie = { type: 'POLYGON', points: [] };
        const reference = {
          name: d.name,
          color: '#DCC69F',
          borderColor: undefined,
          borderWidth: undefined,
          isInterval: false,
          title: d.name,
          intervalStart: undefined,
          intervalEnd: undefined,
        };
        reference.color = d.color;
        reference.borderColor = d.borderColor;
        reference.borderWidth = d.borderWidth;
        reference.tagClass = d.isUm ? 'polygonDriveUnitClass' : undefined
        d.geometry.coordinates[0].forEach(p => {
          serie.points.push({
            lat: p[1], lng: p[0], value: d.name, filters: [],
            tag: `${d.name}`,
          });
        });
        references.push(reference);
        serie.businessData = d.isUm ? { isDriveUnit: true, zoneId: d._id } : { isDriveUnit: false, zoneId: d._id }
        series.push(serie);
      });
      return { series, references };
    },

    getPointOfInterestGroupMap(pois, poiCategories) {
      const poiSerie = { type: 'CIRCLES', points: [] }
      const poiRefs = []
      const poiMarkSerie = { type: "MARKERS", points: [] }
      const poiMarkRefs = []
      pois.forEach(p => {
        const categoryId = p.categoryId;
        const point = {
          lat: p.center[0],
          lng: p.center[1],
          value: p.name,
          filters: [],
          tag: `${p.name}`,
          radius: p.radius
        };
        poiSerie.points.push(point)
        poiRefs.push({
          name: p.name,
          color: '#3388FF90',
          borderColor: '#3388FF',
          borderWidth: 0.5,
          isInterval: false,
          title: p.name,
          intervalStart: undefined,
          intervalEnd: undefined,
        });
        const categoryEntity = poiCategories.find(category => categoryId === category._id)
        if (categoryEntity) {
          poiMarkRefs.push({
            name: p.name,
            color: '#3388FF90',
            borderColor: '#3388FF',
            borderWidth: 0.5,
            isInterval: false,
            title: p.name,
            intervalStart: undefined,
            intervalEnd: undefined,
          });
          const pointMark = {
            lat: p.center[0],
            lng: p.center[1],
            value: p.name,
            filters: [],
            tag: `${p.name}`,
            radius: p.radius
          };
          pointMark.marker = {
            title: "",
            type: "base64",
            ref: categoryEntity.logo,
            size: 40,
            tooltipDirection: "right",
            tooltipPermanent: false,
            tooltipBorderColor: "rgb(0,176,240)",
            businessData: {
              number: 0,
              direction: "northeast",
              stopped: false
            }
          }
          poiMarkSerie.points.push(pointMark);
        }
      });
      return { poiSerie, poiRefs, poiMarkSerie, poiMarkRefs };
    },
    getMap(zones, pois, poiCategories) {
      const map = {
        id: parseInt(Math.floor(Math.random() * 100000).toString()),
        groups: [
          {
            name: 'Zonas',
            title: 'Zonas',
            referenceByInterval: false,
            measure: undefined,
            series: [],
            references: [],
            exclusive: true,
            displayOnStart: true,
            id: "zones"
          },
          {
            name: 'POI',
            title: 'POI',
            measure: undefined,
            referenceByInterval: false,
            series: [],
            references: [],
            exclusive: true,
            displayOnStart: true,
            id: "poi"
          },
          {
            name: 'POI_MARKER',
            title: 'POI_MARKER',
            measure: undefined,
            referenceByInterval: false,
            series: [],
            references: [],
            exclusive: true,
            displayOnStart: true,
            id: "poi"
          }
        ],
        filters: [],
        info: {}
      };
      const [groupZones, groupPoi, groupPoiMarker] = map.groups;
      if (this.showZones) {
        const { series, references } = this.getZoneGroupMap(zones);
        groupZones.references = references;
        groupZones.series = series;
      }
      if (this.showPoi) {
        const { poiSerie, poiRefs, poiMarkSerie, poiMarkRefs } = this.getPointOfInterestGroupMap(pois, poiCategories);
        groupPoi.references = poiRefs;
        groupPoi.series = [poiSerie];
        groupPoiMarker.references = poiMarkRefs;
        groupPoiMarker.series = [poiMarkSerie];
      }
      return map;
    },
    centerMap(selectedItem) {
      this.$refs.zoneMap.centerMap(selectedItem.position)
    },
    categorySelected(selectedItem) {
      this.selectedCategoryFilter = selectedItem;
      this.getZonesAndPOIS()
    },
    tabSelected(id) {
      this.selectedTab = id
      if (id === 'tab-map') {
        this.change()
      }
    },
    change() {
      const mapRef = this.$refs['ZoneABMComponent']
      if (mapRef) mapRef.change()
    },
    async convertToDriveUnit(data) {
      if (data != null) {
        const id = data._id || data.zoneId
        const isDriveUnit = data.isUm === true || data.isDriveUnit === true
        if (id != null) {
          if (isDriveUnit) {
            this.driveUnitDialogTitle = i18n.t('driveUnit.dialog.titleEdit')
            await this.editDriveUnit(id)
          } else {
            this.driveUnitDialogTitle = i18n.t('driveUnit.dialog.titleNew')
            await this.loadFields(id)
          }
        }
      }
    },
    /**
     * Carga los datos para la conversión a UM
     * @param {*} id
     */
    async loadFields(id) {
      const data = await zoneService.getZone(id)
      if (data) {
        this.openDriveUnitDialog()
        const newModel = {
          update: false,
          zoneId: id,
          geometry: data.geometry,
          enterpriseId: data.properties.enterpriseId,
          disableEnterpriseSelector: data.properties.enterpriseId ? true : false,
          Name: data.properties.name,
          ecologicalUnitId: null,
          farmId: null,
          area: null,
          headWidth: null,
          variety: null,
          age: null,
          description: null,
          harvestSpeed: null,
          machineEfficiency: null,
          plantingWidth: null,
          nivelationWidth: null,
          visibility: null,
          distanceToMill: null,
          tchp: null,
          tch: null,
          TCHR: null,
          grooves: null,
          kgPerGroove: null,
          groovesPerHectare: null
        }
        const model = this.dialog.model
        Object.assign(model, newModel)
      } else {
        this.showSnackbar({
          visible: true,
          text: this.$t('zone.error.couldNotLoadDriveUnitDialog'),
          timeout: 6000,
          style: SnackbarStyle.ERROR
        })
      }
    },
    /**
     * Abre el dialog para creación de UM
     */
    openDriveUnitDialog() {
      const bread = {
        key: DialogDriveUnit,
        disabled: true,
        text: this.$t('driveUnit.name')
      }
      this.pushBread(bread)
      this.showDriveUnitDialog = true
    },
    /**
     * Click fuera del dialog
     */
    clickOutside() {
      this.cancel()
    },
    /**
     * Cancelar
     */
    cancel() {
      this.showDriveUnitDialog = false
    },
    /**
     * Cada vez que se modifica la selección de empresa, se cargan
     */
    async enterpriseSelectedFunction(newValue) {
      this.enterpriseSelected = newValue._id ? newValue._id : newValue;
      this.selectedCategoryFilter = '';
      await this.getZonesAndPOIS()
      await this.updateSelectors()
      await this.initEnterpriseCategoriesSelector()
    },
    /**
    * Carga los datos para la edición de la UM
    * @param {*} zoneId
    */
    async editDriveUnit(zoneId) {
      const data = await driveUnitService.getDriveUnitByZoneId(zoneId)
      if (data) {
        this.openDriveUnitDialog()
        const newModel = {
          update: true,
          driveUnitId: data._id,
          zoneId: zoneId,
          geometry: data.geometry,
          enterpriseId: data.enterpriseId,
          disableEnterpriseSelector: data.enterpriseId ? true : false,
          Name: data.properties.Name,
          ecologicalUnitId: data.properties.ecologicalUnit,
          farmId: data.properties.farm,
          area: data.properties.area,
          headWidth: data.properties.headWidth,
          variety: data.properties.variety,
          age: data.properties.age,
          description: data.properties.description,
          harvestSpeed: data.properties.harvestSpeed,
          machineEfficiency: data.properties.machineEfficiency,
          plantingWidth: data.properties.plantingWidth,
          nivelationWidth: data.properties.nivelationWidth,
          visibility: data.properties.visibility,
          distanceToMill: data.properties.distanceToMill,
          tchp: data.properties.tchp,
          tch: data.properties.tch,
          TCHR: data.properties.TCHR,
          grooves: data.properties.grooves,
          kgPerGroove: data.properties.kgPerGroove,
          groovesPerHectare: data.properties.groovesPerHectare,
          lastUpdate: data.properties.lastUpdate,
          showLastUpdate: data.properties.lastUpdate ? true : false
        }
        const model = this.dialog.model
        Object.assign(model, newModel)
      } else {
        this.showSnackbar({
          visible: true,
          text: this.$t('zone.error.couldNotLoadDriveUnitDialog'),
          timeout: 6000,
          style: SnackbarStyle.ERROR
        })
      }
    },
    /**
     * Cuando se cambia al tab del mapa, se actualizan los datos
     */
    async updateMap() {
      await this.getZonesAndPOIS()
      if (this.$refs.zoneTable) this.$refs.zoneTable.getData(true)
    },
    /**
     * Guardar los valores del showCluster
     */
    changeShowCluster(showClustersValue) {
      this.showClustersValue = showClustersValue
      configurationService.setShowCluster(showClustersValue, 'ZoneABM')
    },
    /**
     * Abrir el diálogo de cambio de color
     * @param {*} selectedZones - Zonas seleccionadas
     */
    openChangeColorDialog(selectedZones) {
      this.selectedZonesForColor = selectedZones
      this.showColorDialog = true
    },
    /**
     * Manejar la selección de color
     * @param {*} data - Datos con zonas y color seleccionado
     */
    async onColorSelected(data) {
      try {
        const zoneIds = data.zones.map(zone => zone._id)
        const colorData = {
          color: data.color,
          borderColor: data.borderColor,
          borderWidth: data.borderWidth
        }
        await zoneService.updateMultipleColors(zoneIds, colorData)
        
        this.showSnackbar({
          visible: true,
          text: this.$t('zone.colorUpdatedMessage'),
          timeout: 6000,
          style: SnackbarStyle.SUCCESS
        })
        
        // Actualizar los datos
        await this.getZonesAndPOIS()
        if (this.$refs.zoneTable) {
          this.$refs.zoneTable.getData(true)
        }
        
        this.showColorDialog = false
        this.selectedZonesForColor = []
      } catch (error) {
        console.error('Error updating zone colors:', error)
        this.showSnackbar({
          visible: true,
          text: this.$t('error.internal'),
          timeout: 6000,
          style: SnackbarStyle.ERROR
        })
      }
    },
        closeColorDialog() {
            this.showColorDialog = false
            this.selectedZonesForColor = []
        }
  },
  watch: {
    async selectedTab(newValue) {
      if (newValue === 'tab-map') {
        await this.updateMap()
        if (this.zone) this.zoneToEdit = this.zone;
        if (this.poi) this.poiToEdit = this.poi;
      }
    }
  }
}
